import { Modal } from "components";
import TargetRateView from "components/cards/target-rate-view";
import { useTargetRate } from "hooks/data/use-target-rates";

export default function ViewTargetRateContainer({
  open,
  setOpen,
  rateId,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  rateId: string;
}) {
  const { loading, targetRate } = useTargetRate(rateId);

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="View Rate Details"
      description="Details of the target rate are shown below"
    >
      <TargetRateView rate={targetRate} />
    </Modal>
  );
}
